<template>
  <section class="question-section" @click="previewImg">
      <separator-vertical :text="label">
        <slot name="head"></slot>
      </separator-vertical>
      <slot name="jianda"></slot>
      <div class="html-content-box" v-html="htmlContent"></div>
      <slot name="body"></slot>
      <div v-show="imgSrc">
         <el-image
            ref="image"
            :src="imgSrc"
            style="width: 100px; height: 0"
            :preview-src-list="srcList">
          </el-image>
      </div>
  </section>
</template>
<script>
import SeparatorVertical from './SeparatorVertical'
import { Image } from 'element-ui'
import 'element-ui/lib/theme-chalk/image.css'

export default {
  name: 'HtmlContainer',
  components: {
    'separator-vertical': SeparatorVertical,
    'el-image': Image
  },
  data () {
    return {
      imgSrc: '',
      srcList: []
    }
  },
  props: {
    label: {
      type: String,
      default: '',
      required: true
    },
    'htmlContent': {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    blockAnalysis () {
      return this.analysis
    },
    blockSolution () {
      return this.answer
    }
  },
  methods: {
    previewImg (event) {
      if (event.target.className === 'img-responsive') {
        const $img = event.target
        this.srcList = [$img.src]
        this.imgSrc = $img.src
        this.$refs.image.clickHandler()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/styles/_varaible.scss';
  .question-section{
    padding: 16px 64px;
    @media screen and (max-width:1024px) {
      padding: 16px 24px;
    }
    &.is-focus{
      background: #F7FBFF;
    }
    font-size:14px;
    font-family:SFProDisplay;
    font-weight:400;
    line-height:22px;
    color: $secondary;
  }
  .html-content-box /deep/{
    padding-left: 8px;
    .img-responsive{
      cursor: pointer;
    }
    .MathJax_Display {
        overflow: auto;
    }
  }
  .el-icon-zoom-out::before,
  .el-icon-zoom-in::before,
  .el-icon-full-screen::before,
  .el-icon-refresh-left::before,
  .el-icon-refresh-right::before,
  .el-icon-circle-close::before{
    font-family: "CometIcons";
    font-style: normal;
  }
  .el-image-viewer__actions__divider{
    display: none;
  }
  .el-icon-circle-close::before{
    content: "\e63f";
  }
  .el-icon-zoom-out::before{
    content: "\e66b";
  }
  .el-icon-zoom-in::before{
    content: "\e667";
  }
  .el-icon-refresh-left::before {
    content: "\e668";
  }
    .el-icon-full-screen{
    display: none;
  }
    .el-icon-refresh-right{
    display: none;
  }

</style>
